export default "__VITE_ASSET__0VjxOZMN__"